import styled from "styled-components"

const TreatmentsPageWrapper = styled.div``

export default TreatmentsPageWrapper
